export default "__VITE_ASSET__a326e92e__"